import React, { useState, useEffect } from 'react';
import Model from '../../../model';

const useSticky = (ref) => {

    const [ sticky, setSticky ] = useState(false)
    const [ animated, setAnimated ] = useState(false);
    const [ interacted, setInteracted ] = useState(false);
    const { setHeaderSticky } = Model.view;

    useEffect(() => {
        const scrollOffset = typeof (window) !== 'undefined' ? window.scrollY : 0;
        setSticky(scrollOffset > 50);
        const io = new IntersectionObserver(handleIntersection);
        io.observe(ref.current)
        if (typeof (window) !== 'undefined') {
            const handler = () => {
                setInteracted(true);
            }
            window.addEventListener('mousewheel', handler, { once: true });
            window.addEventListener('mousedown', handler, { once: true });
            window.addEventListener('touchmove', handler, { once: true });
            return () => {
                io.disconnect();
                window.removeEventListener('mousewheel', handler);
                window.removeEventListener('mousedown', handler);
                window.removeEventListener('touchmove', handler);
            }
        }
    }, []);

    useEffect(() => {
        if (interacted) {
            setAnimated(true);
        }
    }, [ interacted ])

    const handleIntersection = (e) => {
        setSticky(!e[0].isIntersecting);
    }

    useEffect(() => {
        setHeaderSticky(sticky);
    }, [sticky])

    return {
        sticky,
        animated,
        interacted
    }

}

export default useSticky;
